import PropTypes from "prop-types";
import {SetMetalTierSelect} from '../../assets/constants/metalTierList';
import { currentMetalTierSelect } from '../../store/actions';
import { connect } from 'react-redux';

const MetalTierSelect = (props) => {

    const { MetalTierList, metalTierSelect} = props;
    props.currentMetalTierSelect(metalTierSelect);

    const handleSelect = (e) =>{
        SetMetalTierSelect(e.target.value);        
        props.currentMetalTierSelect(e.target.value);
        props.onMetalTierSelect(e.target.value);
    }

    return(
        <div className="d-flex justify-content-end">
            <div className="btn-group">
            <select className="btn btn-info dropdown-toggle btn" value={metalTierSelect} onChange={handleSelect}>
                {
                    MetalTierList && MetalTierList.map(el => <option value={el} key={el}> {el} </option>)
                }
            </select>
            </div>
        </div>
    )
}

MetalTierSelect.propTypes ={
    MetalTierList : PropTypes.array,
}
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
    };
  }
export default connect(mapStateToProps, {currentMetalTierSelect})(MetalTierSelect);